export default __webpack_public_path__ + "static/media/location_preview_s2_a_classic_caper.9dccf801.svg";